// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"a17202a8","130":"fcbe9d7c","132":"a17202a8","724":"3db6b8e3","878":"0ec1deec"}[chunkId] + ".chunk.css";
};